import { nanoid } from "nanoid/non-secure";
import { isBrowser } from "./is.js";
export function noop() {
    // do nothing
}
export function generateId() {
    return nanoid(10);
}
export function removeUndefined(obj) {
    const result = {};
    for (const key in obj) {
        const value = obj[key];
        if (value !== undefined) {
            result[key] = value;
        }
    }
    return result;
}
export function getOptionUpdater(options) {
    return function (key, value) {
        if (value === undefined)
            return;
        const store = options[key];
        store.set(value);
    };
}
export function builderActions(node, params) {
    const unsubs = [];
    params.builders.forEach((builder) => {
        const act = builder.action(node);
        if (act) {
            unsubs.push(act);
        }
    });
    return {
        destroy: () => {
            unsubs.forEach((unsub) => {
                if (unsub.destroy) {
                    unsub.destroy();
                }
            });
        }
    };
}
export function getAttrs(builders) {
    const attrs = {};
    builders.forEach((builder) => {
        Object.keys(builder).forEach((key) => {
            if (key !== "action") {
                attrs[key] = builder[key];
            }
        });
    });
    return attrs;
}
export function disabledAttrs(disabled) {
    return disabled ? { "aria-disabled": true, "data-disabled": "" } : {};
}
export function bitWrap(storeValues, bit) {
    return {
        ...storeValues,
        [`data-bits-${bit}`]: ""
    };
}
export function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}
export function styleToString(style) {
    return Object.keys(style).reduce((str, key) => {
        if (style[key] === undefined)
            return str;
        return str + `${key}:${style[key]};`;
    }, "");
}
export function setTransitionTimes(transitionTimes, transitionsObj) {
    if (!isBrowser)
        return;
    const { transition, transitionConfig, inTransition, inTransitionConfig, outTransition, outTransitionConfig } = transitionsObj;
    if (transition) {
        if (transitionConfig) {
            const { delay, duration } = transition(document.body, transitionConfig);
            const time = calcTime(delay, duration);
            transitionTimes.set({
                in: time,
                out: time
            });
            return;
        }
        const { delay, duration } = transition(document.body);
        const time = calcTime(delay, duration);
        transitionTimes.set({
            in: time,
            out: time
        });
        return;
    }
    let inTime = 0;
    let outTime = 0;
    if (inTransition) {
        if (inTransitionConfig) {
            const { delay, duration } = inTransition(document.body, inTransitionConfig);
            inTime = calcTime(delay, duration);
        }
        else {
            const { delay, duration } = inTransition(document.body);
            inTime = calcTime(delay, duration);
        }
    }
    if (outTransition) {
        if (outTransitionConfig) {
            const { delay, duration } = outTransition(document.body, outTransitionConfig);
            outTime = calcTime(delay, duration);
        }
        else {
            const { delay, duration } = outTransition(document.body);
            outTime = calcTime(delay, duration);
        }
    }
    transitionTimes.set({
        in: inTime,
        out: outTime
    });
}
function calcTime(delay, duration) {
    const numDelay = delay ?? 0;
    const numDuration = duration ?? 0;
    return numDelay + numDuration;
}
